import { useRulesQueryConfig } from '@/entities/user/access-rule';
import { attributesQueryConfig } from '@/entities/srm/ci';

import {
  ciTypesListQueryConfig,
  ciTypesTreeQueryConfig,
} from '@/entities/srm/ci';
import { hiTypesQueryConfig } from '@/entities/monitoring/hi';
import { userAttributesQueryConfig } from '@/entities/user/user-attribute';
import { getErrorStatus } from '@/shared/api/intercepted-error';
import type { UseQueryOptions } from '@tanstack/react-query';

const withPrefetchableRetry = (query: UseQueryOptions): UseQueryOptions => ({
  ...query,
  retry: (failureCount, error) => {
    const status = getErrorStatus(error);
    if (status && status >= 400 && status < 500) return false;
    return failureCount < 1;
  },
  retryDelay: 1000,
  useErrorBoundary: false,
});

export const PREFETCHABLE_QUERIES = [
  useRulesQueryConfig,
  attributesQueryConfig,
  userAttributesQueryConfig,
  ciTypesListQueryConfig,
  ciTypesTreeQueryConfig,
  hiTypesQueryConfig,
].map(withPrefetchableRetry);
